<conditional-loading-spinner [whenShow]="isComponentLoading"></conditional-loading-spinner>
<div class="position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center bg-light" *ngIf="showNoFriendsMessage">
    <div class="col-md-5 p-lg-5 mx-auto my-5">
        <h1 class="display-4 font-weight-normal">Get a match</h1>
        <p class="lead font-weight-normal">And start chatting with people across the globe sharing similar problems</p>
        <button class="btn btn-outline-secondary" (click)="findFriend()">Start</button>
    </div>
</div>
<div class="position-absolute m-3" *ngIf="!showNoFriendsMessage">
    <mdb-icon fas class="fa-lg grey-text toggle" *ngIf="animationFriends" (click)="showHideFriends()" icon="angle-double-left"></mdb-icon>
    <mdb-icon fas class="fa-lg toggle" *ngIf="!animationFriends" (click)="showHideFriends()" icon="angle-double-right"></mdb-icon>
    <span class="badge rounded-pill badge-notification bg-danger" *ngIf="!animationFriends && getTotalNewMessages() > 0">{{getTotalNewMessages()}}</span>
</div>
<div class="row pt-5 px-3">
    <div class="col-md-4 mb-5 animated" *ngIf="friends.length > 0 && showFriends" [ngClass]="{'slideInLeft': animationFriends, 'slideOutLeft': !animationFriends}">
        <input mdbInput type="search" class="form-control mb-2" placeholder="Filter by name or disorder" [(ngModel)]="friendNameFilter">
        <div class="friends-col">
            <div class="container">
                <div class="row border-bottom py-1" [ngClass]="{'active z-depth-1': friend?.id === chatFriend?.id}" *ngFor="let friend of friends| ChatFilter: friendNameFilter">
                    <div class="col-xl-3">
                        <div class="avatar-container text-center my-3">
                            <div class="position-relative">
                                <div class="d-none d-xl-block">
                                    <div class="online-indicator" [style.background-color]="indicatorColor(friend)"></div>
                                </div>
                                <img *ngIf="friend" [src]="getAvatar(friend.avatarId)" class="profile-photo-lg d-none d-lg-inline">
                            </div>

                            <h4 class="profile-link mt-4">{{friend.name}}</h4>
                            <div>
                                <div class="d-xl-none d-inline-flex">
                                    <div class="online-indicator-small" [style.background-color]="indicatorColor(friend)"></div>
                                    <span>{{onlineStatus(friend).get('status')}}</span>
                                </div>
                            </div>
                            <span *ngIf="onlineStatus(friend).get('lastOnline') !== 'unknown'" class="last-online-text">Last login {{onlineStatus(friend).get('lastOnline')}} ago</span>
                        </div>
                    </div>
                    <div class="col-xl-6 my-auto text-center p-1">
                        <div class="container">
                            <mdb-badge class="dbadge grey lighten-1 m-1 " pill="true " *ngFor="let d of getTranslatedDisorders(friend)">{{d}}</mdb-badge>
                        </div>
                    </div>
                    <div class="col-xl-3 my-auto text-center">
                        <button class="btn btn-primary chat" (click)="setChatFriend(friend) ">
                            <span class="badge rounded-pill badge-notification bg-danger" *ngIf="friend.newMessages && friend.newMessages > 0">{{friend.newMessages}}</span>
                            <mdb-icon far icon="paper-plane" class="mr"></mdb-icon>
                            </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center mt-2" *ngIf="friends.length > 0">
            <gb-action-button (onClick)="findFriend()" [whenDisabled]="isNewFriendTimeout" [isLoading]="findNewFriendLoading" [text]="'Find new friend'" [iconClass]="'search'"></gb-action-button>
            <countdown [hidden]="!isNewFriendTimeout" (event)="onTimerFinished($event)" #cd [config]="{demand: false, leftTime: newFriendTimeout}"></countdown>
        </div>
    </div>
    <div class="col-md mb-5 mx-xs-1" *ngIf="chatFriend">
        <div class="container p-0 z-depth-1 border border-primary mw-100">

            <div class="card">
                <div class="row w-100">
                    <div class="pl-3 w-100">
                        <div class="py-2 pr-1 pl-2 border-bottom">
                            <div class="d-flex align-items-center py-1">
                                <div class="position-relative">
                                    <img [src]="getAvatar(chatFriend.avatarId)" class="rounded-circle mr-1">
                                </div>
                                <div class="flex-grow-1 pl-3">
                                    <strong><b>{{chatFriend.name}}</b></strong>
                                    <div class="text-muted small"><em>{{chatFriend.statusMessage}}</em></div>
                                </div>
                                <div class="btn-group" mdbDropdown>
                                    <button mdbDropdownToggle class="btn btn-light border btn-lg px-3"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal feather-lg"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg></button>
                                    <div class="dropdown-menu dropdown-menu-left">
                                        <a class="dropdown-item" (click)="showDeleteFriendPopup = true">Unmatch</a>
                                        <!-- <li>
                                            <hr class="dropdown-divider" />
                                        </li>
                                        <a class="dropdown-item text-danger">Report</a> -->
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="position-relative">
                            <conditional-loading-spinner [whenShow]="isMessagesLodaing"></conditional-loading-spinner>
                            <div #scroll class="chat-messages w-100 pl-2 pt-1" (scroll)="onScroll()">
                                <div *ngIf="messages && messages.length === 0" class="text-center">
                                    <app-conversation-starter #starter (start)="startConversation()"></app-conversation-starter>
                                </div>
                                <div *ngFor='let m of messages' [ngClass]="isMyMessage(m) ? 'chat-message-right pb-2 mr-1' : 'chat-message-left pb-2'">
                                    <div class="text-center d-flex align-items-center">
                                        <!-- <img [src]="getMessageAvatar(m)" class="rounded-circle mr-1"> -->
                                        <div class="text-muted small text-nowrap">{{formatDate(m)}}</div>
                                    </div>
                                    <div class="d-inline-block">
                                        <div class="msg-content flex-shrink-1 rounded py-2 px-3" [ngClass]="isMyMessage(m) ? 'mr-2 blue accent-2 text-white' : 'ml-2 bg-light'">
                                            <div class="font-weight-bold mb-1" *ngIf="m.senderName.includes('conversation starter')">{{m.senderName}}</div>
                                            {{m.content}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="flex-grow-0 py-3 pl-3 border-top">
                            <form [formGroup]="form" (keydown.enter)="$event.preventDefault()">
                                <div class="input-group">
                                    <textarea #textarea (keyup.enter)="sendMessage()" (keyup)="textareaOverflow()" minLength="1" rows="1" type="text" class="form-control mt-1 rounded" formControlName="message" placeholder="Message"></textarea>
                                    <mdb-icon far icon="smile" (click)="toggleEmoji()" class="mx-1 emoji-toggle d-none d-sm-block"></mdb-icon>
                                    <emoji-mart *ngIf="showEmoji" showPreview="false" emoji="grinning" title="" [style]="{ position: 'absolute', bottom: '50px', right: '40px' }" (emojiClick)="addEmoji($event)"></emoji-mart>
                                    <button mdbBtn mdbWavesEffect (click)="sendMessage()" color="blue" class="btn-sm send-message" type="submit" [disabled]="!form.valid">
                                        <mdb-icon fas icon="angle-left"></mdb-icon>
                                    </button>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<confirmation-popup [show]="showDeleteFriendPopup" [header]="'Unmatch with ' + chatFriend?.name + '?'" [message]="'You will not be able to match with this user in the future'" (button1Action)="unfriend(); showDeleteFriendPopup=false" [button1Text]="'Yes'"
    [button2Text]="'Cancel'" (button2Action)="showDeleteFriendPopup = false"></confirmation-popup>